import {
  PlanType,
  SubscriptionStatus,
} from '@showbie-socrative/socrative-utils';
import { isAfter } from 'date-fns';

import { Subscription } from '../../../../api/subscription';

export function calculateSubscriptionState(
  subscription: Pick<
    Subscription,
    'endDate' | 'cancelAtEndDate' | 'status' | 'plan'
  > | null
) {
  if (!subscription) return 'None' as const;

  const { endDate, cancelAtEndDate, status, plan } = subscription;

  if (
    isAfter(Date.now(), new Date(endDate)) &&
    status === SubscriptionStatus.Canceled
  ) {
    return 'Expired' as const;
  }

  if (
    cancelAtEndDate &&
    status === SubscriptionStatus.Active &&
    ![PlanType.Organization, PlanType.Complete].includes(plan)
  ) {
    return 'Cancelling' as const;
  }

  if (status === SubscriptionStatus.Active) return 'Valid' as const;

  if (status === SubscriptionStatus.PastDue) return 'PastDue' as const;

  if (cancelAtEndDate && status === SubscriptionStatus.Trialing)
    return 'CancellingTrial' as const;

  if (status === SubscriptionStatus.Trialing) return 'Trial' as const;

  if (status === SubscriptionStatus.Disputed) return 'Disputed' as const;

  return 'Expired' as const;
}

export type SubscriptionState = ReturnType<typeof calculateSubscriptionState>;
